import React from 'react';

const SvgArrowRight = (props) => (
  <svg width={6} height={10} {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.243 0L0 1.306l.625.65L3.515 5 .625 8.045 0 8.695 1.243 10l.617-.657 2.897-3.037L6 5 4.757 3.694 1.86.657z"
      opacity={0.2}
    />
  </svg>
);

export default SvgArrowRight;
